import { z } from 'zod';
import { crowdexPermissionModeSchema } from '../request-schemas';

/**
 * `GET`/`PUT /api/settings/started-work`: what the conversations started for the user (by their
 * assistant, a project's lead, a task, an app) may do without asking them, at most
 * (docs/adr-tasks-and-roles.md §6). A starter asks for less; a saved agent's cap lowers it too.
 */
export const startedWorkSettingSchema = z
  .object({ permissionMode: crowdexPermissionModeSchema })
  .strict();
export type StartedWorkSetting = z.infer<typeof startedWorkSettingSchema>;
